import { createContext } from 'react';

const homeContext = createContext();

export default homeContext;